// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tFEb","importantInfo":"styles_importantInfo__1VGME"};